import { render, staticRenderFns } from "./ScoreTableSisSystem.vue?vue&type=template&id=19e03269&scoped=true&"
import script from "./ScoreTableSisSystem.vue?vue&type=script&lang=js&"
export * from "./ScoreTableSisSystem.vue?vue&type=script&lang=js&"
import style0 from "./ScoreTableSisSystem.vue?vue&type=style&index=0&id=19e03269&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e03269",
  null
  
)

export default component.exports